import React from "react";

export const Logo = ({ className = "", size = "md" }) => {
  const sizes = {
    sm: "text-base",
    md: "text-xl",
    lg: "text-3xl",
  };
  return (
    // <div
    //   data-testid="brand-logo"
    //   className={`flex items-center gap-2 select-none ${className}`}
    // >
    //   <div className="flex items-center">
    //     <span
    //       className={`${sizes[size]} font-heading tracking-tight text-[#F1F5F9]`}
    //     >
    //       Blue
    //     </span>
    //     <span
    //       className={`${sizes[size]} font-heading tracking-tight text-[#00E5FF]`}
    //     >
    //       Line
    //     </span>
    //     <span className="ml-1.5 w-1.5 h-1.5 bg-[#FFB300]" />
    //   </div>
    //   <span className="hidden sm:inline-block font-mono-accent text-[10px] text-[#4A6E8C]">
    //     / control systems
    //   </span>
    // </div>
<div style={{ margin: -3, padding: 0, textAlign: "left" }}>
  <img
    src="logo.png"
    alt="logo"
    height={300}
    width={300}
    style={{ display: "block", margin: 0 }}
  />
</div> 
         
  );
};

export default Logo;
